/**
 * Smoothly scrolls to a section by ID with offset for sticky header
 * @param sectionId - The ID of the section to scroll to (without the # symbol)
 * @param offset - The offset from the top in pixels (default: 80px for sticky header)
 */
export const scrollToSection = (sectionId: string, offset: number = 80) => {
  // Wait for DOM to be ready
  setTimeout(() => {
    const element = document.getElementById(sectionId);
    if (element) {
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  }, 100); // Small delay to ensure DOM is ready
};
